//брат сабзиро
/*
Приложение андроид которое просто показывает веб через вебвью, ему нужны параметры из AppsFlyer для трэкинга траффика
отправляется на апи для андроида
*/
import querystring from "querystring";
import { get } from "./common/fetch";

const ua = window.navigator.userAgent;
const isWebView = /wvbo_full/g.test(ua);
const isAnalyticsWebView = /wvbo/g.test(ua) && !isWebView;
const search = window.location.search.slice(1);

export async function submitAppsFlyerParameters() {
  if ((isAnalyticsWebView || isWebView) && search != null) {
    const parsedSearch = querystring.parse(search);
    //мы просто подменим название ключа из урла вебвью на то которое просит бэкенд и отправим
    let promiseTraffic = Promise.resolve();
      promiseTraffic = get("/api/setTrafficSource", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: "full_ref=" + encodeURIComponent(search) + "&site_url=" + encodeURIComponent(window.location.href)
      });

    let promiseAvd =
      parsedSearch.apps_flyer_uid &&
      parsedSearch.android_advertising_id &&
      parsedSearch.application_fingerprint
        ? get(`/api/android-adv-id`, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: querystring.stringify({
              appsflyer_id: parsedSearch.apps_flyer_uid,
              android_adv_id: parsedSearch.android_advertising_id,
              application_fingerprint: parsedSearch.application_fingerprint
            })
          })
        : null;

    return await Promise.all([promiseTraffic, promiseAvd]);
  }
}



// WEBPACK FOOTER //
// ./src/components/Scorpion.js